import script from "./FreelancerSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FreelancerSidebar.vue?vue&type=script&setup=true&lang=js"

import "./FreelancerSidebar.vue?vue&type=style&index=0&id=37db5b78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37db5b78"]])

export default __exports__